import * as React from 'react';
import styles from './index.less';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import { AVATAR_URL_PREFIX } from '@/constants';
import FIcons from '@/components/FIcons';
import FCoverImage from '@/components/FCoverImage';
import FListFooter, { listStateAndListMore } from '@/components/FListFooter';
import FLoadingTip from '@/components/FLoadingTip';
import FNoDataTip from '@/components/FNoDataTip';
import FOverflowTooltip from '@/components/FOverflowTooltip';
import FSelect2 from '@/components/FSelect2';
import FInput_Search from '@/components/FInput_Search';

interface FResourceSelectorProps {
  // disabledIDsOrNames?: string[];
  // showRemoveIDsOrNames?: string[];
  selectedResourceIDs: string[];

  onSelect?({ id, name }: { id: string; name: string }): void;

  onDelete?({ id, name }: { id: string; name: string }): void;
}

interface FResourceSelectorStates {
  resourceList: {
    resourceId: string;
    resourceName: string;
    resourceTitle: string;
    resourceType: string[];
    updateDate: string;
    status: 0 | 1;
    latestVersion: string;
    cover: string;
    avatar: string;
    username: string;
    policies: { policyID: string; policyName: string }[];
  }[];
  rPageSize: number;
  rTotal: number;
  rSelect: 'market' | 'my' | 'favorite';
  rInput: string;
}

const initState: FResourceSelectorStates = {
  resourceList: [],
  rTotal: -1,
  rPageSize: 20,
  rSelect: 'market',
  rInput: '',
};

function FResourceSelector({ selectedResourceIDs, onSelect, onDelete }: FResourceSelectorProps) {
  const [$selectOptions, set$selectOptions, get$selectOptions] = FUtil.Hook.useGetState<
    { label: string; value: FResourceSelectorStates['rSelect'] }[]
  >([
    { label: '资源市场', value: 'market' },
    { label: '我的资源', value: 'my' },
    { label: '我的收藏', value: 'favorite' },
  ]);

  const [$state, $setState] = AHooks.useSetState<FResourceSelectorStates>(initState);

  const [$showDeleteResourceID, set$showDeleteResourceID, get$showDeleteResourceID] =
    FUtil.Hook.useGetState<string>('');

  const [$listState, set$listState, get$listState] = FUtil.Hook.useGetState<
    'loading' | 'noData' | 'noSearchResult' | 'loaded'
  >('loading');
  const [$listMore, set$listMore, get$listMore] = FUtil.Hook.useGetState<
    'loading' | 'andMore' | 'noMore'
  >('loading');

  AHooks.useMount(() => {
    // debugger;
    fetchResources(true);
  });

  const { run } = AHooks.useDebounceFn(
    () => {
      fetchResources(true);
    },
    {
      wait: 300,
    },
  );

  async function fetchResources(restart: boolean = false) {
    let resourceList: FResourceSelectorStates['resourceList'] = [];
    if (!restart) {
      resourceList = $state.resourceList;
      set$listMore('loading');
    } else {
      set$listState('loading');
    }
    let totalItem: number = -1;
    if ($state.rSelect === 'favorite') {
      const params: Parameters<typeof FServiceAPI.Collection.collectionResources>[0] = {
        skip: resourceList.length,
        limit: FUtil.Predefined.pageSize,
        keywords: $state.rInput,
      };
      const {
        data: data_favoriteResources,
      }: {
        data: {
          totalItem: number;
          dataList: {
            resourceId: string;
            resourceName: string;
          }[];
        };
      } = await FServiceAPI.Collection.collectionResources(params);
      // console.log(data, '*********************** sd89fuijosdlkfjlkj');
      // debugger;
      totalItem = data_favoriteResources.totalItem;
      if (data_favoriteResources.dataList.length > 0) {
        const {
          data: data_resourceBatch,
        }: {
          data: {
            resourceId: string;
            resourceName: string;
            resourceTitle: string;
            coverImages: string[];
            updateDate: string;
            resourceType: string[];
            status: 0 | 1;
            latestVersion: string;
            username: string;
            userId: number;
            policies: { policyId: string; policyName: string; status: 0 | 1 }[];
          }[];
        } = await FServiceAPI.Resource.batchInfo({
          resourceIds: data_favoriteResources.dataList
            .map((i) => {
              return i.resourceId;
            })
            .join(','),
        });
        // console.log(data_resourceBatch, '*********************** sd89fuijosdlkfjlkj');
        // debugger;
        resourceList = [
          ...resourceList,
          ...data_favoriteResources.dataList.map<FResourceSelectorStates['resourceList'][number]>(
            (r1) => {
              const r = data_resourceBatch.find((rr) => {
                return rr.resourceId === r1.resourceId;
              });
              return {
                resourceId: r1.resourceId,
                resourceName: r1.resourceName,
                resourceTitle: r?.resourceTitle || '',
                resourceType: r?.resourceType || [],
                updateDate: FUtil.Format.formatDateTime(r?.updateDate || '', true),
                status: r?.status || 0,
                latestVersion: r?.latestVersion || '',
                cover: r?.coverImages[0] ?? '',
                avatar: `${AVATAR_URL_PREFIX}${r?.userId}`,
                username: r?.username || '',
                policies:
                  r?.policies.map((p) => {
                    return {
                      policyID: p.policyId,
                      policyName: p.policyName,
                    };
                  }) || [],
              };
            },
          ),
        ];
      }
    } else {
      const params: Parameters<typeof FServiceAPI.Resource.list>[0] = {
        // startResourceId: resourceList[0]?.resourceId,
        skip: resourceList.length,
        // limit: storageObjectDepSelector.rPageSize,
        limit: FUtil.Predefined.pageSize,
        keywords: $state.rInput,
        status: $state.rSelect === 'my' ? undefined : 1,
        isSelf: $state.rSelect === 'my' ? 1 : undefined,
      };
      const {
        data: data_resourceList,
      }: {
        data: {
          totalItem: number;
          dataList: {
            resourceId: string;
            resourceName: string;
            resourceTitle: string;
            coverImages: string[];
            updateDate: string;
            resourceType: string[];
            status: 0 | 1;
            latestVersion: string;
            username: string;
            userId: number;
            policies: { policyId: string; policyName: string; status: 0 | 1 }[];
          }[];
        };
      } = await FServiceAPI.Resource.list(params);
      // console.log(data_resourceList, '*********************** sd89fuijosdlkfjlkj');
      // debugger;
      totalItem = data_resourceList.totalItem;
      resourceList = [
        ...resourceList,
        ...data_resourceList.dataList.map<FResourceSelectorStates['resourceList'][number]>((r) => ({
          resourceId: r.resourceId,
          resourceName: r.resourceName,
          resourceTitle: r.resourceTitle,
          resourceType: r.resourceType,
          updateDate: FUtil.Format.formatDateTime(r.updateDate, true),
          status: r.status,
          latestVersion: r.latestVersion,
          cover: r.coverImages[0] ?? '',
          avatar: `${AVATAR_URL_PREFIX}${r.userId}`,
          username: r.username,
          policies:
            r?.policies.map((p) => {
              return {
                policyID: p.policyId,
                policyName: p.policyName,
              };
            }) || [],
        })),
      ];
    }

    const { state, more } = listStateAndListMore({
      list_Length: resourceList.length,
      total_Length: totalItem,
      has_FilterCriteria: $state.rInput !== '',
    });

    set$listState(state);
    set$listMore(more);

    $setState({
      rTotal: totalItem,
      resourceList: resourceList,
    });
  }

  return (
    <>
      <div style={{ height: 30 }} />
      <div className={styles.filter}>
        {/* <FDropdownMenu
          options={$selectOptions}
          onChange={(value) => {
            $setState({
              rSelect: value as 'market',
            });
            run();
          }}
          text={$selectOptions.find((op) => op.value === $state.rSelect)?.text || ''}
        /> */}
        <FSelect2
          style={{ width: 120 }}
          options={$selectOptions}
          value={$state.rSelect}
          onChange={(value) => {
            $setState({
              rSelect: value,
            });
            run();
          }}
        />
        {/* <FComponentsLib.FInput.FSearch */}
        <FInput_Search
          value={$state.rInput}
          onChange={(e) => {
            $setState({
              rInput: e.target.value,
            });
            run();
          }}
        />
      </div>
      <div style={{ height: 30 }} />

      {$listState === 'loading' && <FLoadingTip height={600} />}

      {$listState === 'noData' && <FNoDataTip height={600} tipText={'无数据'} />}

      {$listState === 'noSearchResult' && <FNoDataTip height={600} tipText={'无搜索结果'} />}

      {$listState === 'loaded' && (
        <>
          <div className={styles.list}>
            {$state.resourceList.map((i) => {
              return (
                <div
                  key={i.resourceId}
                  className={styles.itemCard}
                  onMouseEnter={() => {
                    if (selectedResourceIDs.includes(i.resourceId)) {
                      set$showDeleteResourceID(i.resourceId);
                    }
                  }}
                  onMouseLeave={() => {
                    set$showDeleteResourceID('');
                  }}
                >
                  <div
                    className={styles.itemCard_item}
                    onClick={() => {
                      if (!selectedResourceIDs.includes(i.resourceId)) {
                        onSelect?.({ id: i.resourceId, name: i.resourceName });
                      }
                    }}
                  >
                    <div className={styles.itemCard_item_content}>
                      <FCoverImage src={i.cover} width={104} style={{ flexShrink: 0 }} />
                      <div style={{ flexShrink: 1, width: '100%' }}>
                        <FOverflowTooltip
                          text={i.resourceTitle || i.resourceName}
                          style={{
                            maxWidth: 380,
                            color: '#222',
                            fontSize: '14px',
                            lineHeight: '20px',
                            fontWeight: '600',
                          }}
                        />
                        <div style={{ height: 7 }} />
                        <div className={styles.itemCard_item_content_info}>
                          <img className={styles.avatar} src={i.avatar} alt={''} />
                          <FOverflowTooltip
                            text={`${i.username} | 资源类型 ${i.resourceType.join(
                              '/',
                            )} | 更新时间 ${i.updateDate}`}
                            style={{
                              maxWidth: 340,
                              flexShrink: 1,
                              lineHeight: '18px',
                              color: '#999',
                              fontSize: '12px',
                            }}
                          />
                        </div>
                        <div style={{ height: 7 }} />
                        <div className={styles.itemCard_item_content_policies}>
                          {i.policies.map((p) => {
                            return (
                              <label key={p.policyID}>
                                <FIcons.FContract style={{ fontSize: 14 }} />
                                <span>{p.policyName}</span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {selectedResourceIDs.includes(i.resourceId) && (
                      <label className={styles.itemCard_item_selectedLabel}>
                        <FIcons.FCheck style={{ fontSize: 14, color: '#2784FF' }} />
                        <span>已添加</span>
                      </label>
                    )}
                  </div>

                  {$showDeleteResourceID === i.resourceId && (
                    <div
                      className={styles.itemCard_deleteButton}
                      onClick={() => {
                        onDelete?.({ id: i.resourceId, name: i.resourceName });
                        set$showDeleteResourceID('');
                      }}
                    >
                      移除
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <FListFooter
            state={$listMore}
            onClickLoadMore={() => {
              fetchResources(false);
            }}
          />
        </>
      )}
    </>
  );
}

export default FResourceSelector;
